import api from "./api";

const AuthService = {
  login: async (credentials) => {
    try {
      const res = await api.post("/userLogin/login", {
       loginIdOrEmail: credentials.loginIdOrEmail,
       loginPassword: credentials.password,
      });
      return res.data; // assuming backend returns { success: true, message: "", data: {} }
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Login failed");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  changePassword: async ({ employeeId, oldPassword, newPassword }) => {
  try {
    const res = await api.post("/userLogin/changePassword", {
      employeeId,
      oldPassword,
      newPassword,
    });
    return res.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "Password change failed");
    } else {
      throw new Error("Unable to connect to server");
    }
  }
  },
};

export default AuthService;
